import { render, staticRenderFns } from "./SlideSwitch.vue?vue&type=template&id=8f627cf8&scoped=true&"
import script from "./SlideSwitch.vue?vue&type=script&lang=js&"
export * from "./SlideSwitch.vue?vue&type=script&lang=js&"
import style0 from "./SlideSwitch.vue?vue&type=style&index=0&id=8f627cf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f627cf8",
  null
  
)

export default component.exports